import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CircleIcon from '@mui/icons-material/CircleOutlined';
import ReportIcon from '@mui/icons-material/Report';
import WarningIcon from '@mui/icons-material/Warning';
import React from 'react';
import {CircularProgress} from '../../../src/ProgressIndicator';
import {FileInputTextMap, ValidationStatus} from '../types';

export function getFileStatusIcon(status: ValidationStatus, textMap: FileInputTextMap): React.ReactElement {
    switch (status) {
        case 'unvalidated':
            return (
                <CircleIcon
                    aria-label={textMap.fileStatusIconLabels.unvalidated}
                    color='disabled'
                    fontSize='small'
                    titleAccess={textMap.fileStatusIconLabels.unvalidated}
                />
            );
        case 'success':
            return (
                <CheckCircleIcon
                    aria-label={textMap.fileStatusIconLabels.success}
                    color='primary'
                    fontSize='small'
                    titleAccess={textMap.fileStatusIconLabels.success}
                />
            );
        case 'warning':
            return (
                <WarningIcon
                    aria-label={textMap.fileStatusIconLabels.warning}
                    color='warning'
                    fontSize='small'
                    titleAccess={textMap.fileStatusIconLabels.warning}
                />
            );
        case 'error':
            return (
                <ReportIcon
                    aria-label={textMap.fileStatusIconLabels.error}
                    color='error'
                    fontSize='small'
                    titleAccess={textMap.fileStatusIconLabels.error}
                />
            );
        case 'validating':
        default:
            return (
                <CircularProgress
                    aria-label={textMap.fileStatusIconLabels.validating}
                    size='small'
                    title={textMap.fileStatusIconLabels.validating}
                    variant='indeterminate'
                />
            );
    }
}
